module.exports = __webpack_public_path__ + "static/media/EuCML.68e898ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/EuCML.jpg
// module id = 1747
// module chunks = 1